/**
 * 跨浏览器 / 桌面端会话协调：可靠追踪本窗口是否获焦。
 * Electron 在切到外部浏览器时未必及时更新 document.hasFocus，需配合 blur 事件。
 */
let initialized = false;
let driverWindowFocused = true;

function syncDriverWindowFocused(): void {
  if (typeof document === "undefined") return;
  driverWindowFocused =
    document.visibilityState === "visible" &&
    (typeof document.hasFocus === "function" ? document.hasFocus() : true);
}

export function initDriverWindowFocusTracker(): void {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  syncDriverWindowFocused();
  window.addEventListener("focus", syncDriverWindowFocused, true);
  window.addEventListener("blur", syncDriverWindowFocused, true);
  document.addEventListener("visibilitychange", syncDriverWindowFocused);
}

export function isDriverWindowFocused(): boolean {
  if (typeof document === "undefined") return true;
  if (!initialized) {
    initDriverWindowFocusTracker();
  }
  return driverWindowFocused;
}
